import { StyledOption } from './styles'

export interface OptionNodeProps {
  width: number
  onClick: (value: string) => void
  error?: boolean
  disabled?: boolean
  selected?: boolean
  value: string
  children: React.ReactNode
  centered?: boolean
}

export const OptionNode = ({
  width,
  onClick,
  error,
  disabled,
  selected,
  value,
  children,
  centered,
}: OptionNodeProps) => (
  <StyledOption
    centered={centered}
    disabled={disabled}
    error={error}
    onClick={() => {
      if (!disabled) onClick(value)
    }}
    selected={selected}
    value={value}
    width={width}
  >
    {children}
  </StyledOption>
)
